import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import Icon from '@mdi/react'
import styled from 'styled-components'

export const WLANListItemBody = styled.div`
  flex: 1;
  color: ${theme.colors.otterWarmBlack};
  max-width: initial;
  word-break: word;
`
export const WLANListBtn = styled(CommonLinkButton)`
  display: flex;
`

export const WLANListHeaderTitle = styled.div`
  flex: 1;
  flex-direction: row;
  flex-wrap: nowrap;
  color: ${theme.colors.otterWarmBlack};
  font-weight: 900;
  max-width: initial;
  white-space: nowrap;
  word-break: word;
  margin-left: 120px;

  @media ${theme.devices.tablet} {
    margin-left: 50px;
  }

  @media ${theme.devices.mobile} {
    margin-left: 25px;
  }

  @media ${theme.devices.mediumDesktop} {
    margin-left: 50px;
  }
`

export const WLANListHeaderTitleSub = styled.div`
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const WLANListRightBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  gap: 15px;
  flex: 1;
`

export const WLANListRightBlockSecondary = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  gap: 15px;
  flex: 1;

  @media ${theme.devices.mobile} {
    display: none;
  }
`

export const WLANListLeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  gap: 10px;
  width: 100%;
`

export const WLANListIcon = styled(Icon)<{ open?: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? 'rotate(-180deg)' : 'rotate(0)')};
`

export const WLANListRow = styled.div<{ hover?: boolean }>`
  display: flex;
  align-items: center;
  padding: 5px 5px;

  ${({ hover }) => (hover ? 'background:#eeeeee' : 'background:#ffffff')};

  @media ${theme.devices.tablet} {
    gap: 18px;

    ${WLANListLeftBlock} {
      align-items: center;
      flex-direction: row;
    }
  }
`

export const WLANSeparator = styled.div`
  height: 1px;
  background-color: ${theme.colors.lightGrey};
`
